<script>
  import textInput from './text-input';
  import {checkResetCode} from "../helpers/field-checker.helper";
  import {F_ERR_ENUM} from "../enum/field-error.enum";

  export default {
    extends: textInput,
    name: "reset-code-input",
    methods: {
      computeErrors () {
        if (!checkResetCode(this.content)) {
          this.setError(F_ERR_ENUM.INCORRECT, 'error_invalid_code');
          return;
        }
        this.setError(F_ERR_ENUM.INCORRECT, null);
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/reset-code-input.vue